import { CssBaseline, ThemeProvider } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib";
import { useModalState } from "@src/appV2/redesign/system/ui-components";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";
import { useEffect } from "react";

import { PageWrapper } from "../components/PageWrapper";
import { Navbar } from "../Navbar";
import { CrossMarketplaceIntroSlide } from "../Onboarding/OnboardingFlowContainer/components/CrossMarketplaceIntroSlide";
import { InstantBookSlide } from "../Onboarding/OnboardingFlowContainer/ShiftsEducationStep/components/InstantBookSlide";
import { InstantPaySlide } from "../Onboarding/OnboardingFlowContainer/ShiftsEducationStep/components/InstantPaySlide";
import { UploadDocumentsSlide } from "../Onboarding/OnboardingFlowContainer/ShiftsEducationStep/components/UploadDocumentsSlide";
import { UnfamiliarEducationDialog } from "../Onboarding/UnfamiliarMarketplaceEducation/UnfamiliarEducationDialog";
import { useShouldShowUnfamiliarMarketplaceEducation } from "../Onboarding/UnfamiliarMarketplaceEducation/useShouldShowUnfamiliarMarketplaceEducation";
import { ShiftDiscoveryUserFiltersProvider } from "./Filters/useUserFiltersContext";
import { ShiftDiscoveryRouter } from "./Router";

export function ShiftDiscoveryContainer() {
  const { shouldShow: shouldShowUnfamiliarEducation, markAsSeen } =
    useShouldShowUnfamiliarMarketplaceEducation("shifts");
  const educationModalState = useModalState("closed");
  const { openModal } = educationModalState;

  useEffect(() => {
    if (shouldShowUnfamiliarEducation) {
      openModal();
    }
  }, [shouldShowUnfamiliarEducation, openModal]);

  return (
    <ThemeProvider theme={getTheme()}>
      <CssBaseline />
      <ShiftDiscoveryUserFiltersProvider>
        <PageWrapper>
          <ShiftDiscoveryRouter />
          <Navbar />
        </PageWrapper>
      </ShiftDiscoveryUserFiltersProvider>

      {educationModalState.modalIsOpen && (
        <UnfamiliarEducationDialog
          modalState={educationModalState}
          analyticsEvent={APP_V2_USER_EVENTS.UNFAMILIAR_SHIFTS_EDUCATION_VIEWED}
          onComplete={markAsSeen}
        >
          <CrossMarketplaceIntroSlide unfamiliarMarketplace="shifts" />
          <UploadDocumentsSlide />
          <InstantBookSlide />
          <InstantPaySlide />
        </UnfamiliarEducationDialog>
      )}
    </ThemeProvider>
  );
}
